import { render } from "./kalio-investment-firm-tags.vue?vue&type=template&id=3ab8ad1b"
import script from "./kalio-investment-firm-tags.vue?vue&type=script&lang=js"
export * from "./kalio-investment-firm-tags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__